module.exports = __webpack_public_path__ + "static/media/AX.88e9f5b6.svg";